import { TProductBuildAndPriceLinkProps } from '../components/productBuildAndPriceLink/types/buildAndPriceLink.types';
import useSitecoreContext from './useSitecoreContext';

type TProductPageType = 'line' | 'series' | 'model';

const useGetBuildAndPriceLink = (productPageType: TProductPageType): string => {
  const {sitecoreContext} = useSitecoreContext();
  const componentList = (sitecoreContext?.route?.placeholders['jss-main'] || []) as any[];
  const buildAndPriceLinkComponent = componentList.find((component) => component.componentName === 'ProductBuildAndPriceLink');

  if (!buildAndPriceLinkComponent) {
    return '';
  }

  const apiData = (buildAndPriceLinkComponent as TProductBuildAndPriceLinkProps)?.fields?.apiData;
  const lineData = apiData;
  const seriesData = lineData?.series;
  const modelData = seriesData?.model;

  switch (productPageType) {
    case 'line': 
          return lineData?.buildAndPriceUrlForLine || '';
    case 'series':
         if (seriesData?.directLinktoBuildAndPrice) {
          return seriesData?.buildAndPriceUrlForSerie || '';
         }
         return lineData?.buildAndPriceUrlForLine || '';
    case 'model':
          if (modelData?.directLinktoBuildAndPrice) {
            return modelData?.buildAndPriceUrlForModel || '';
          }
          return seriesData?.buildAndPriceUrlForSerie || '';
    default: 
        return '';
  }
};

export default useGetBuildAndPriceLink;
